// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueMeta from 'vue-meta'
import { store } from './store'
//import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue);
Vue.use(VueI18n);
Vue.use(VueMeta);

// 언어 설정
import { ko } from './lang/ko';
import { en } from './lang/en';
import { ja } from './lang/ja';
import { zh } from './lang/zh';
import { zh_TW } from './lang/zh_TW';

const messages = {
    ko,
    en,
    ja,
    zh,
    zh_TW
};

let gen_lang = 'ko';
if( typeof generator_lang !== 'undefined' ) gen_lang = generator_lang; // 설정된 언어가 있다면 덮어주기

const i18n = new VueI18n({
    locale: gen_lang, // app js 호출 하기 전 선언해야함.
    messages
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js